import m from '@bitstillery/mithril'
import {MithrilComponent} from '@bitstillery/mithril'
import {Button, ButtonGroup, Dialog} from '@bitstillery/common/components/portal'
import {get_route, slugify} from '@bitstillery/common/lib/utils'
import {$t, config} from '@bitstillery/common/app'
import type {GetOfferResponse} from '@bitstillery/common/api/fact2server'

/** An offer the popup can show: one that carries a popup image. */
export type OfferWithPopupImage = GetOfferResponse & {offer_portal_popup_image_s3_key: string}

export function has_popup_image(offer: GetOfferResponse): offer is OfferWithPopupImage {
    return Boolean(offer.offer_portal_popup_image_s3_key)
}

interface PopupOfferAttrs {
    offer: OfferWithPopupImage
    onclose: () => void
}

export class PopupOffer extends MithrilComponent<PopupOfferAttrs> {
    // @i18n ignore: popup.offer.**
    view(vnode: m.Vnode<PopupOfferAttrs>) {
        const offer_slug = slugify(vnode.attrs.offer.title)
        // Acting on the offer dismisses it too, otherwise returning to a CMS page re-opens the popup.
        const to_offer = () => {
            vnode.attrs.onclose()
            void m.route.set(
                get_route('/shop', {
                    offer: vnode.attrs.offer.hash,
                }),
            )
        }
        return (
            <Dialog
                className='c-dialog-offer dialog-portal'
                footer={
                    <ButtonGroup>
                        <Button onclick={to_offer} text={$t('offer.popup.show_offer')} type='info' variant='cta' />
                    </ButtonGroup>
                }
                onclose={vnode.attrs.onclose}
                title={
                    vnode.attrs.offer.offer_portal_popup_title
                        ? vnode.attrs.offer.offer_portal_popup_title
                        : $t(`popup.offer.${offer_slug}.title`)
                }
            >
                <img
                    className='popup-image'
                    src={`${config.product_photo_host}/${vnode.attrs.offer.offer_portal_popup_image_s3_key}`}
                    onclick={to_offer}
                />
                <p>
                    {vnode.attrs.offer.offer_portal_popup_text
                        ? vnode.attrs.offer.offer_portal_popup_text
                        : $t(`popup.offer.${offer_slug}.text`)}
                </p>
            </Dialog>
        )
    }
}
